import { useEffect, useState } from "react";
import { ModalHeader, ScrollableContent } from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import tw from "tailwind-styled-components";
import moment from "moment";
import DateRangePicker from "../Common/DateRangePicker";
import CustomTooltip from "../Tooltip";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Pie } from "react-chartjs-2";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import { CircularProgress } from "@mui/material";
import { FiAlertOctagon } from "react-icons/fi";

ChartJS.register(ArcElement, Tooltip, Legend);
/* ================= SAMPLE DATA ================= */

const sampleComplaintStats1 = {
  totalComplaints: 42,
  resolvedComplaints: 31,

  propertyWise: [
    { property: "Kipinn Sector 62", count: 14 },
    { property: "Kipinn Alpha 1", count: 10 },
    { property: "Kipinn Knowledge Park", count: 8 },
    { property: "Kipinn Pari Chowk", count: 5 },
  ],

  categoryWise: [
    { category: "Maintenance", count: 16 },
    { category: "Electricity", count: 10 },
    { category: "Cleaning", count: 7 },
    { category: "WiFi", count: 5 },
  ],

  topTenants: [
    { tenant: "Rahul Sharma", count: 5 },
    { tenant: "Amit Kumar", count: 4 },
    { tenant: "Rohit Singh", count: 3 },
    { tenant: "Ankit Gupta", count: 2 },
  ],
};

const sampleComplaintStats = {
  totalComplaints: 42,
  resolvedComplaints: 31,

  propertyWise: [
    { property: "Kipinn Sector 62", count: 14 },
    { property: "Kipinn Alpha 1", count: 10 },
    { property: "Kipinn Knowledge Park", count: 8 },
    { property: "Kipinn Pari Chowk", count: 5 },
  ],

  categoryWise: [
    { category: "Maintenance", count: 16 },
    { category: "Electricity", count: 10 },
    { category: "Cleaning", count: 7 },
    { category: "WiFi", count: 5 },
  ],

  topTenants: [
    { tenant: "Rahul Sharma", property: "Kipinn Sector 62", count: 5 },
    { tenant: "Amit Kumar", property: "Kipinn Alpha 1", count: 4 },
    { tenant: "Rohit Singh", property: "Kipinn Knowledge Park", count: 3 },
    { tenant: "Ankit Gupta", property: "Kipinn Sector 62", count: 2 },
  ],
};

const ComplaintAnalyticsSideModal = ({ handleClose, token }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [apiResp, setApiResp] = useState(null);

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );


  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/complaint/analytics?startDate=${startDate}&endDate=${endDate}&term=1`,
      {
        headers: {
          authorization: "Bearer" + " " + token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiResp(res?.data);
    }
  };

  const getError = (res) => { };

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    if (token && startDate && endDate) {
      getListMutate();
    }
  }, [token, startDate, endDate]);

  const complaintStats = sampleComplaintStats;

  // const categoryChartData = {
  //   labels: complaintStats.categoryWise.map(c => c.category),
  //   datasets: [
  //     {
  //       data: complaintStats.categoryWise.map(c => c.count),
  //       backgroundColor: [
  //         "#6366F1",
  //         "#22C55E",
  //         "#F59E0B",
  //         "#EF4444",
  //         "#06B6D4",
  //       ],
  //       borderWidth: 0,
  //     },
  //   ],
  // };

  const categoryChartData = {
    labels: apiResp?.graphData?.map(c => c.category),
    datasets: [
      {
        data: apiResp?.graphData?.map(c => c.count),
        backgroundColor: [
          "#6366F1", // Indigo
          "#22C55E", // Green
          "#F59E0B", // Amber
          "#EF4444", // Red
          "#06B6D4", // Cyan
          "#8B5CF6", // Violet
          "#EC4899", // Pink
          "#14B8A6", // Teal
          "#F97316", // Orange
          "#84CC16"  // Lime
        ],
        borderWidth: 0,
      },
    ],
  };

  const pieOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        // position: "bottom",
        // labels: { boxWidth: 12 },
      },
    },
  };

  const resolutionRate1 = Math.round(
    (complaintStats.resolvedComplaints / complaintStats.totalComplaints) * 100
  );

  const resolutionRate =
    apiResp?.stats?.totalComplaints > 0
      ? Math.round(
        (apiResp?.stats?.resolvedComplaints /
          apiResp?.stats?.totalComplaints) *
        100
      )
      : 0;

  const maxProperty = Math.max(...complaintStats.propertyWise.map(p => p.count));
  const maxCategory = Math.max(...complaintStats.categoryWise.map(c => c.count));

  const submitHandler = (values) => {
    setStartDate(moment(values.startDate).format("YYYY-MM-DD"));
    setEndDate(moment(values.endDate).format("YYYY-MM-DD"));
  };

  return (
    <Container>
      <div className="flex items-center justify-between bg-white py-4 px-5 shadow-md bg-gradient-to-r from-primary-color to-[#00A0FF]">
        <div className="flex items-center gap-3 min-w-0">
          <div
            className="h-11 w-11 rounded-2xl bg-[#EEF6FF] flex items-center justify-center shrink-0">
            <div className="text-[#0078BD] text-lg">
              <FiAlertOctagon />
            </div>
          </div>
          <div className="min-w-0 text-white">
            <h1 className="text-lg font-semibold text-white">
              Complaint Analytics
            </h1>
            <DateLabel onClick={() => setShowDatePicker(true)}>
              {moment(startDate).format("DD MMM yyyy")} – {moment(endDate).format("DD MMM yyyy")}
            </DateLabel>
          </div>
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={handleClose}
            className="h-10 w-10 rounded-xl hover:bg-primary-color/40 flex items-center justify-center transition-all duration-200 text-white">
            <MdClose size={20} />
          </button>
        </div>
      </div>

      {(isLoading || isRefetching) && (
        <div className="flex justify-center items-center my-40">
          <CircularProgress size={40} />
        </div>
      )}
      {!isLoading && !isRefetching && (
        <div className="px-5">
          <ScrollableContent className="overflow-y-auto max-h-[calc(100dvh-100px)] pb-10 mt-5">

            <Content>
              {/* KPI SECTION */}
              <Grid>
                <KpiCard>
                  <KpiTitle>Total Complaints</KpiTitle>
                  <KpiValue>{apiResp?.stats?.totalComplaints}</KpiValue>
                  <KpiSub>Reported in selected period</KpiSub>
                </KpiCard>

                <KpiCard>
                  <KpiTitle>Resolved</KpiTitle>
                  <KpiValue>{apiResp?.stats?.resolvedComplaints}</KpiValue>

                  <ProgressWrapper>
                    <ProgressBar style={{ width: `${resolutionRate}%` }} />
                  </ProgressWrapper>

                  <KpiSub>{resolutionRate}% resolution rate</KpiSub>
                </KpiCard>

              </Grid>

              {/* PROPERTY ANALYTICS */}

              <Section>
                <SectionHeader>
                  <SectionTitle>Properties with Most Complaints</SectionTitle>
                </SectionHeader>
                <List>
                  {apiResp?.propertyWise && apiResp.propertyWise.length > 0 ? (
                    apiResp.propertyWise.map((p, i) => (
                      <Item key={i}>
                        <ItemTop>
                          <PropertyName>{p.property}</PropertyName>
                          <Count>{p.count}</Count>
                        </ItemTop>

                        <ProgressTrack>
                          <ProgressBar
                            style={{
                              width: `${apiResp?.stats?.totalComplaints
                                ? (p.count / apiResp.stats.totalComplaints) * 100
                                : 0
                                }%`,
                            }}
                          />
                        </ProgressTrack>
                      </Item>
                    ))
                  ) : (
                    <EmptyState>No complaints reported for any property in this period.</EmptyState>
                  )}
                </List>

                {/* <List>
                {apiResp?.propertyWise?.map((p, i) => (
                  <Item key={i}>
                    <ItemTop>
                      <PropertyName>{p.property}</PropertyName>
                      <Count>{p.count}</Count>
                    </ItemTop>

                    <ProgressTrack>
                      <ProgressBar
                        style={{ width: `${(p.count / apiResp?.stats?.totalComplaints) * 100}%` }}
                      />
                    </ProgressTrack>
                  </Item>
                ))}
              </List> */}
              </Section>

              {/* CATEGORY ANALYTICS */}

              {/* <Section>
                <SectionHeader>
                  <SectionTitle>Complaint Categories</SectionTitle>
                </SectionHeader>

                {apiResp?.graphData && apiResp.graphData.length > 0 ? (
                  <ChartWrapper>
                    <Pie data={categoryChartData} options={pieOptions} />
                  </ChartWrapper>
                ) : (
                  <EmptyState>No complaint categories found for this period.</EmptyState>
                )}
              </Section> */}

              <Section>
                <SectionHeader>
                  <SectionTitle>Complaint Categories</SectionTitle>
                </SectionHeader>

                {apiResp?.graphData?.length > 0 ? (
                  <>
                    <ChartWrapper>
                      <Pie data={categoryChartData} options={pieOptions} />
                    </ChartWrapper>

                    <CategoryList>
                      {apiResp.graphData.map((c, i) => {
                        const percent = apiResp?.stats?.totalComplaints
                          ? Math.round((c.count / apiResp.stats.totalComplaints) * 100)
                          : 0;

                        return (
                          <CategoryItem key={i}>
                            <CategoryLeft>
                              <ColorDot
                                style={{
                                  backgroundColor:
                                    categoryChartData.datasets[0].backgroundColor[i],
                                }}
                              />
                              <CategoryName>{c.category}</CategoryName>
                            </CategoryLeft>

                            <CategoryRight>
                              <CategoryCount>{c.count}</CategoryCount>
                              <CategoryPercent>{percent}%</CategoryPercent>
                            </CategoryRight>
                          </CategoryItem>
                        );
                      })}
                    </CategoryList>
                  </>
                ) : (
                  <EmptyState>No complaint categories found for this period.</EmptyState>
                )}
              </Section>

              {/* TENANT ANALYTICS */}

              <Section>
                <SectionHeader>
                  <SectionTitle>Tenants with Most Complaints</SectionTitle>
                </SectionHeader>

                {apiResp?.topTenants && apiResp.topTenants.length > 0 ? (
                  <TenantGrid>
                    {apiResp.topTenants.map((t, i) => (
                      <TenantCard key={i}>
                        <TenantInfo>
                          <TenantName>{t.name}</TenantName>
                          <TenantProperty>{"#" + t.mobile}</TenantProperty>
                        </TenantInfo>
                        <CustomTooltip label="Resolved/Total">
                          <TenantBadge>{t?.resolved || 0}/{t?.count || 0}</TenantBadge>
                        </CustomTooltip>
                      </TenantCard>
                    ))}
                  </TenantGrid>
                ) : (
                  <EmptyState>No tenants with complaints in this period.</EmptyState>
                )}
              </Section>

              {/* <Section>
              <SectionTitle>Tenants with Most Complaints</SectionTitle>

              {complaintStats.topTenants.map((t, i) => (
                <TenantRow key={i}>
                  <TenantName>{t.tenant}</TenantName>
                  <TenantCount>{t.count}</TenantCount>
                </TenantRow>
              ))}
            </Section> */}

            </Content>
          </ScrollableContent>

          <DateRangePicker
            show={showDatePicker}
            onClose={() => setShowDatePicker(false)}
            showOnlyMonths={true}
            initialStartDate={new Date(startDate)}
            initialEndDate={new Date(endDate)}
            submitHandler={submitHandler}
          />

        </div>
      )}
    </Container>
  );
};

/* ================= Styled ================= */

const Container = tw.div`
bg-gray-50 w-full h-full flex flex-col
`;

const Header = tw.div`
flex items-center justify-between bg-primary-color py-4 px-5 text-white
`;

const DateLabel = tw.span`text-xs opacity-80 cursor-pointer`;

const Content = tw.div`
flex flex-col gap-6
`;

const Grid = tw.div`
grid grid-cols-2 gap-4
`;

const KpiTitle = tw.p`
text-sm text-gray-500
`;

const KpiValue = tw.p`
text-2xl font-semibold text-gray-800 mt-1
`;

const KpiSub = tw.p`
text-xs text-gray-400 mt-1
`;

const ProgressWrapper = tw.div`
bg-gray-200 rounded-full h-2 mt-3 overflow-hidden
`;

const ProgressBar = tw.div`
bg-green-500 h-2 rounded-full
`;

const SectionTitle = tw.p`
text-sm font-semibold text-gray-700 mb-2
`;

const BarRow = tw.div`
flex items-center gap-3
`;

const Label = tw.span`
text-sm text-gray-600 w-40
`;

const BarWrapper = tw.div`
flex-1 bg-gray-200 rounded-full h-2 overflow-hidden
`;

const Bar = tw.div`
bg-blue-500 h-2 rounded-full
`;

const Count = tw.span`
text-sm font-semibold text-gray-700
`;

const TenantRow = tw.div`
flex justify-between text-sm text-gray-600
`;

const TenantCount = tw.span`
font-semibold text-gray-800
`;

const SectionHeader = tw.div`
flex items-center justify-between mb-3
`;

const ChartWrapper = tw.div`
h-[260px] flex items-center justify-center
`;

const TenantGrid = tw.div`
grid grid-cols-2 gap-3
`;

const TenantCard = tw.div`
bg-gray-50 hover:bg-white border rounded-xl p-4 
flex items-center justify-between 
transition shadow-sm hover:shadow-md
`;

const TenantInfo = tw.div`
flex flex-col
`;

const TenantName = tw.span`
text-sm font-semibold text-gray-800
`;

const TenantProperty = tw.span`
text-xs text-gray-500 mt-1
`;

const TenantBadge = tw.span`
bg-primary-color text-white text-sm font-semibold 
px-3 py-1 rounded-full
`;

const KpiCard = tw.div`
bg-white rounded-2xl border p-6 shadow-sm
`;

const Section = tw.div`
bg-white rounded-2xl border p-6 shadow-sm flex flex-col
`;

// const Section = tw.div`
// bg-white rounded-2xl border border-gray-200
// p-6 shadow-sm
// `;

// const SectionHeader = tw.div`
// flex items-center justify-between mb-5
// `;

// const SectionTitle = tw.p`
// text-base font-semibold text-gray-800
// `;

const List = tw.div`
flex flex-col gap-5
`;

const Item = tw.div`
flex flex-col gap-2
`;

const ItemTop = tw.div`
flex items-center justify-between
`;

const PropertyName = tw.span`
text-sm text-gray-700 font-medium
`;

// const Count = tw.span`
// text-sm font-semibold text-gray-900
// `;

const ProgressTrack = tw.div`
w-full h-2.5 rounded-full bg-gray-100 overflow-hidden
`;

const EmptyState = tw.div`
text-sm text-gray-400 text-center py-6
`;

const CategoryList = tw.div`
flex flex-col gap-3 mt-4
`;

const CategoryItem = tw.div`
flex items-center justify-between text-sm
`;

const CategoryLeft = tw.div`
flex items-center gap-2
`;

const ColorDot = tw.div`
w-3 h-3 rounded-sm
`;

const CategoryName = tw.span`
text-gray-600
`;

const CategoryRight = tw.div`
flex items-center gap-3
`;

const CategoryCount = tw.span`
font-semibold text-gray-800
`;

const CategoryPercent = tw.span`
text-gray-400 text-xs
`;

// const ProgressBar = tw.div`
// h-full rounded-full
// bg-gradient-to-r from-blue-500 to-blue-600
// transition-all duration-500
// `;
export default ComplaintAnalyticsSideModal;